import { Typography } from '@mui/material';
import { getCountryDisplayName } from '@utils/geo';
import lookup from 'country-code-lookup';
import React from 'react';

interface IAuditCardGeoValueProps {
	value: string;
}

const AuditCardGeoValue: React.FC<IAuditCardGeoValueProps> = ({ value }) => {
	const country = lookup.countries.find((c) => c.iso2 === value);
	return (
		<Typography
			variant="subtitle1"
			display="inline"
			data-testid="audit-card-item-geo"
		>
			{country ? getCountryDisplayName(country) : value}
		</Typography>
	);
};

export default AuditCardGeoValue;
